import React from 'react'
import Setting from './Setting'
import { ROUTER } from '../router/constants'

const SettingRoom = () => {
  return (
    <div>
      <Setting backLink={ROUTER.ROOM} checkLink={ROUTER.ROOM}/>
    </div>
  )
}

export default SettingRoom
